import { useTranslation } from 'react-i18next';
import { NewDropdown } from 'app/components/ui';
import { Typography } from 'app/components/ui';

interface TaxonomyOption {
  label: string;
  value: string;
}

interface TaxonomyProps {
  currentValue: string;
  onValueChange: (value: string) => void;
  options: TaxonomyOption[];
}

export const TaxonomyPicker = ({ currentValue, options, onValueChange }: TaxonomyProps) => {
  const { t } = useTranslation('taxonomy');

  if (!options.length) {
    return (
      <Typography variant="body-5" fontWeight="bold" color="#547ba2">
        {t('no.taxonomies.found')}
      </Typography>
    );
  }
  return <NewDropdown currentValue={currentValue} label={`${t('title')}:`} options={options} onUpdate={onValueChange} showSelectBox />;
};
